import { render } from "./InventorySavePage.vue?vue&type=template&id=17cd1d8f"
import script from "./InventorySavePage.vue?vue&type=script&lang=js"
export * from "./InventorySavePage.vue?vue&type=script&lang=js"
script.render = render

export default script